<script>
export default {
    components: {},
    props: {
        headingText: {
            default: 'No Results to Show'
        }
    },
    computed: {},
    methods: {},
    async mounted() {
        
    },
}
</script>

<template>
    <b-card>
        <h6>{{ headingText }}</h6>
        <slot />
    </b-card>
</template>

<style lang="scss">
</style>
